<template>
  <div
    class="flex w-full items-center relative transition-all ease-in-out"
    :style="{ height: containerHeight }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div
      v-for="(connection, index) in connections"
      :key="connection.id"
      :style="{
        left: hover ? '0' : `${index * 1.5}rem`,
        top: hover ? `${index * 3}rem` : '0',
        zIndex: `${connections.length + index}`,
      }"
      class="absolute transition-all ease-in-out"
    >
      <div class="flex">
        <div
          class="w-10 flex-shrink-0"
          :class="
            connection.image ? '' : 'border border-truegray-300 rounded-full'
          "
        >
          <ProfileImage
            :connection="connection"
            :border="false"
            :white-border="true"
          />
        </div>
        <div
          :class="hover ? 'opacity-100' : 'opacity-0 w-0 h-0 overflow-hidden'"
          class="ml-4 flex flex-col justify-center transition-all"
        >
          <p :title="connection.name" class="clamp-1 pr-1">
            {{ connection.name }}
          </p>

          <div
            v-if="employmentDetails"
            :title="connection.job_title + ' - ' + connection.company"
            class="flex flex-row items-center gap-2 text-truegray-500 pr-1"
          >
            <p class="text-xs text-truegray-500 clamp-1">
              <span>{{ connection.job_title }}</span>
              <span v-if="!hideCompany && connection?.company"
                >- {{ connection.company }}</span
              >
            </p>
            <span
              v-if="showContactDetails && connection.email"
              class="hover:text-primary cursor-pointer"
              @click="copyToClipboard(connection.email)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
                class="w-4 h-4"
              >
                <path
                  d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z"
                />
                <path
                  d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import ProfileImage from './ImageConnection.vue'
import { EventBus } from '../../../../js/plugins/event-bus.js'

export default defineComponent({
  name: 'StackedConnection',
  components: { ProfileImage },

  props: {
    connections: {
      type: Array,
      required: true,
    },

    employmentDetails: {
      type: Boolean,
      default: true,
    },

    hideCompany: {
      type: Boolean,
      default: false,
    },

    showContactDetails: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const hover = ref(false)

    const containerHeight = computed(() => {
      return hover.value ? `${props.connections.length * 3}rem` : '3rem'
    })

    const copyToClipboard = (value) => {
      navigator.clipboard.writeText(value)
      EventBus.$emit('triggerAlertResponse', {
        status: 'success',
        message: 'Email address copied to clipboard',
      })
    }

    return { hover, containerHeight, copyToClipboard }
  },
})
</script>

<style scoped>
.stack-container {
  position: relative;
  height: auto;
}

.stack-container:hover .stacked-image {
  right: 0 !important;
  top: calc(var(--i) * 3rem) !important;
}

.stacked-image {
  position: absolute;
  transition: all 0.3s ease;
  --i: 0;
}

.stacked-image:nth-child(n + 1) {
  --i: calc(var(--i) + 1);
}
</style>
